<template>
	<div class="gloriousedit">
		
		<headerview :cur="5"></headerview>
		
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					<tipcon :title="'光荣榜'" :name="'光荣榜'" :imgtype="'3'" width="2.12"></tipcon>
				</div>
				<div class="carcon min-h">
					<div class="l_c">
						<div class="frame">
							<div v-for="(items,index) in tablist" :key="index">
							    <div class="signle" @click="changetab(index)">
									<img v-show="tabindex != index" class="" src="../../../static/img/mininav@2x.png" alt=""/>
									<img v-show="tabindex == index && !items.ifshow" class="" src="../../../static/img/mininav_cur@2x.png" alt=""/>
									<img v-show="tabindex == index && items.ifshow" class="" src="../../../static/img/mininavlower@2x.png" alt=""/>
									<span :class="tabindex == index?'text_cur':'text'">{{items.name}}</span>
								</div>
								
								<div v-if="items.ifshow" class="black_son">
									<div :class="sontabindex == y?'sonsignle_cur':'sonsignle'"
									 v-for="(item,y) in items.list" :key="y"
									@click="changesontab(y)">
										{{item}}
									</div>		
								</div>						
												
							</div>
						</div>
						
					</div>
					<div class="r_c">
						<div class="framecon" v-if="!ifdetail">		
							<div class="frame" >						
								<div class="signle" v-for="(item,index) in glorylist" :key="index" @click="seedetail(item)">
									<el-image fit='cover' :src="$imgUrl + item.thumbnail_dictText" alt=""></el-image>
									<div class="title">{{item.title || ''}}</div>
									<div class="cont overfh" :title="item.honoraryTitle">{{item.honoraryTitle || ''}}</div>
								</div>								
							</div>
						</div>
						
						<div class="detailscon" v-if="ifdetail">
							<div class="title">{{informdata.columnId_dictText}}</div>
							<div class="timesource">{{informdata.pubTime}} 
								<!-- <span style="margin-left: 20px;">来源:{{informdata.source}}</span>  -->
							</div>
							<div class="line"></div>
							
							<div class="imgcon">
								<el-image fit='cover' :src="$imgUrl + informdata.thumbnail_dictText" alt=""></el-image>
								<div class="titlename">{{informdata.title || ''}}</div>
								<div class="name" v-if="informdata.honoraryTitle">{{informdata.honoraryTitle || ''}}</div>
							</div>
							<div class="msg" v-html="informdata.hypertext"></div>	
						</div>
						
						<!-- 分页 -->
						<div class="" v-if="!ifdetail">
							<div is='footPage' class="zhini-pagination"
							  :currentPage="pageNo"
							  :totalPage="total"
							  @pageNum="pageNum"  :pagesize='pageSize'></div>
						</div>
						
					</div>
						
				</div>	
					
			</div>
			
		</div>
			
		<footview></footview>
			
	</div>
	
</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import footPage from '../../../components/footpage/footpage.vue'
export default {
  components: {
  	  tipcon,
	  footPage,
  },
  data: function() {
    return {
		tabindex:0,
		sontabindex:0,
		tablist:[
			{name:"全国",list:[
				"优秀少先队员","优秀少先队辅导员","优秀少先队集体","红领巾奖章五星章"
			],ifshow:false},
			{name:"全省",list:[
				"优秀少先队员","优秀少先队辅导员","优秀少先队集体","红领巾奖章四星章"
			],ifshow:false},
		],
		
		infoType:"4",
		glorylist:[],
		informdata:{},
		ifdetail:false,
		pageNo:1,
		total:5,
		pageSize:5,
		
		
    };
  },
  
  mounted() {
		this.$onScrollT()
		this.getGlory()
		
		if(this.$route.query.id) {
			let id = this.$route.query.id
			this.sontabindex = this.$route.query.type
			this.tabindex = this.$route.query.region
			this.tablist[this.tabindex].ifshow = true
			this.ifdetail = true
			this.getHeadlinesDetail(id)
		}else{
			this.tablist[0].ifshow = true
		}
  },

  methods: {
		//光荣榜
		getGlory(){
			var that = this
			var flag = 1
			if(this.sontabindex == 1){
				flag = 2;
			}else if(this.sontabindex == 2){
				flag = 3;
			}
			else if(this.sontabindex == 3){
				// flag = 4;
				flag = this.tabindex==0?5:4
			}
			if(this.tabindex == 0){
				this.infoType = "4"
			}else if(this.tabindex == 1){
				this.infoType = "5"
			}
			this.$get(`web/info/gloryList?flag=${flag}&pageSize=15&pageNo=${this.pageNo}&infoType=${this.infoType}`).then(res=>{
				  if(res.success){
						this.glorylist = res.result.records
						if(parseInt(res.result.total) > 5){
							this.total = res.result.total - 5
						}else{
							this.total = res.result.total
						}
						// this.total = res.result.total
				  }
			})
		},
	  
		changetab(index){
		    this.tabindex = index
			this.ifdetail = false
			
			for(var i =0;i<this.tablist.length;i++){
				if(i != index){
					this.tablist[i].ifshow = false	
				}
			}
			this.tablist[index].ifshow = !this.tablist[index].ifshow
			this.getGlory()
		},
		
		changesontab(index){
			this.sontabindex = index
			this.ifdetail = false
			this.getGlory()
		},
		
		seedetail(item){
			this.ifdetail = true
			this.getHeadlinesDetail(item.id)
		},
		
		//光荣榜
		getHeadlinesDetail(id){
			this.$get(`web/info/queryById?id=${id}`).then(res=>{
				  if(res.success){
						this.informdata = res.result					
				  }
			})
		},
		
		pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getGlory()
		},
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.gloriousedit{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			.carcon{
				display: flex;
				.l_c{
					.frame{
						width: 212px;
						height: 740px;
						background: #FFFFFF;
						border: 1px solid #E6E6E6;
						.signle{
							cursor: pointer;
							height: 50px;
							display: flex;
							align-items: center;
							border-bottom: 1px solid #E6E6E6;
							img,.el-image{
								margin-left: 10px;
								margin-right: 40px;
								width: 10px;
								height: 12px;
							}
							.text_cur,.text{ 
								font-size: 18px;
								font-weight: 400;
							}
							.text_cur{
								color: #E61F26;
							}
							.text{
								color: #000000;
							}
						}
						.black_son{
							margin-top: 10px;
							margin-bottom: 10px;
						}
						.sonsignle_cur,.sonsignle{ 
							cursor: pointer;
							height: 40px;
							line-height: 40px;
							font-size: 16px;
							font-weight: 400;
							margin-left: 20px;
						}
						.sonsignle_cur{
							color: #E61F26;
						}
						.sonsignle{
							color: #333333;
						}
					}
					
				}
				.r_c{
					flex: 1;
					.framecon{
						min-height: 600px;
					}
					.frame{
						display: flex;
						flex-wrap: wrap;
						margin-top: 60px;
						margin-left: 80px;
						.signle{
							cursor: pointer;
							width: 20%;
							// width: 16.6%;
							margin-bottom: 60px;
							text-align: center;
							img,.el-image{
								width: 119px;
								height: 169px;
							}
							.title,.cont{ 
								font-size: 16px;
								font-weight: 400;
								padding: 0px 30px;
								box-sizing: border-box;
							}
							.title{
								color: #333333;
							}
							.cont{
								margin-top: 5px;
								color: #999999;
							}
						}
					}
					
					.detailscon{
						margin-left: 40px;
						.title{
							font-size: 30px;
							font-weight: bold;
							color: #333333;
							text-align: center;
							margin-top: 40px;
							height: 50px;
							line-height: 50px;
						}
						.timesource{
							font-size: 16px;
							color: #666666;
							text-align: center;
							height: 30px;
							line-height: 30px;
						}
						.line{
							width: 100%;
							height: 1px;
							background-color: #ededed;
						}
						
						.imgcon{
							margin-top: 20px;
							display: flex;
							align-items: center;
							flex-direction: column;
							img,.el-image{
								width: 119px;
								height: 169px;
							}
							.titlename,.name{ 
								font-size: 16px;
								font-weight: 400;
								height: 30px;
								line-height: 30px;
							}
							.titlename{
								color: #333333;
							}
							.name{
								text-align: center;
								color: #999999;
							}
						}
						
						.msg{
							padding: 20px 40px 40px 40px;
						}
						
					}	
					
				}
			}
			
			
	    }
		
	}	
	
	
	
	
}

</style>

<style scoped>
/deep/ .msg img{
	max-width: 100%;
	vertical-align: middle
}
</style>